// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Index_boxWrapper__gdPQI {\n    padding: 8px;\n}\n.Index_indexWrapper__cLDxp {\n    margin-top: -55px;\n    padding: 0 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/Mobile/Index/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".boxWrapper {\n    padding: 8px;\n}\n.indexWrapper {\n    margin-top: -55px;\n    padding: 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxWrapper": "Index_boxWrapper__gdPQI",
	"indexWrapper": "Index_indexWrapper__cLDxp"
};
export default ___CSS_LOADER_EXPORT___;
